import { render, staticRenderFns } from "./AttachProccess.vue?vue&type=template&id=c6b7639e&"
import script from "./AttachProccess.vue?vue&type=script&setup=true&lang=js&"
export * from "./AttachProccess.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports